import React, { useState } from 'react';
import cn from 'classnames';
import { Faq } from '../../../../redux/packagePicker/types';
import { useTranslation } from 'react-i18next';
import AddIcon from '@wix/da-ds/pkg/Icons/Add';
import MinusIcon from '@wix/da-ds/pkg/Icons/24x24/Minus';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';

import s from './Faq.scss';

export interface Props {
  faqs: Faq[];
}

const FaqItem: React.FC<{ faq: Faq }> = ({ faq }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className={s['wrapper']} key={faq.title}>
      <h3 className={s['question']} onClick={() => setIsOpen(!isOpen)}>
        {faq.title}{' '}
        {isOpen ? (
          <MinusIcon size={IconSize.MEDIUM} />
        ) : (
          <AddIcon size={IconSize.MEDIUM} />
        )}
      </h3>
      <div
        className={cn(s['answer'], isOpen && s['open'])}
        dangerouslySetInnerHTML={{ __html: faq.body }}
      />
    </div>
  );
};

const Faqs: React.FC<Props> = ({ faqs }) => {
  const { t } = useTranslation();

  if (!faqs || faqs.length === 0) {
    return null;
  }

  return (
    <div className={cn(s['root'])}>
      <h2 className={s['title']}>{t('packagePicker.block.faqs.title')}</h2>
      {faqs.map(faq => (
        <FaqItem key={faq.title} faq={faq} />
      ))}
    </div>
  );
};
Faqs.displayName = 'Faqs';

export default Faqs;
